var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesting(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 37.5c-2.5 9.5-12 8-13 0V25m13 12.5v-6.25m0 6.25h3L63 41m-6.5-16H55m1.5 0h3l3.5-3m-6.5 3v6.25M43.5 25h2m-2 0h-3L37 22m8.5 3v-1c0-2.217.83-3.78 2-4.685M45.5 25H55m0 0v-1c0-2.217-.83-3.78-2-4.685m0 0V16m0 3.315a4.494 4.494 0 00-5.5 0m0 0V16m9 15.25H63M43 37.5h-3L36.5 41m7-9.75H37",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 29.5,
    r: 27.5,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.262 52.414l7.356 7.356-14.63 14.631a5.201 5.201 0 11-7.357-7.356l14.631-14.63zM28.262 47.635l3.997 3.998-6.245 6.245-3.997-3.997z",
    stroke: "#504FE9",
    strokeWidth: 2
  })));
}
export default SvgTesting;